import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IExamdate } from "../../../Pages/ExamDate/IExamDate";

export const AddExamdateSlice = createSlice({
  name: "AddExamdateSlice",
  initialState: {} as IReduxState<IExamdate>,
  reducers: {
    addExamdate: (state, _: PayloadAction<IExamdate>) => {
      state.isLoading = true;
    },
    successaddExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddExamdateResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addExamdate,
  failureaddExamdate,
  successaddExamdate,
  clearAddExamdateResponse,
} = AddExamdateSlice.actions;

export default AddExamdateSlice.reducer;
